import React from 'react';

const AdminHeader = ({ title }) => {
    const user = safeParse(localStorage.getItem('user'));
    const role = String(user?.role || 'user').toLowerCase();
    const isAdmin = role === 'admin' || role === 'super_admin' || role === 'superadmin';

    return (
        <header className="admin-header">
            <div className="header-left">
                <h1>{title}</h1>
            </div>
            <div className="header-right">
                <span className={`admin-role-pill ${isAdmin ? 'admin' : 'user'}`}>
                    <i className={`fas ${isAdmin ? 'fa-user-shield' : 'fa-user'}`}></i>
                    {isAdmin ? 'Admin' : 'User'} role
                </span>
            </div>
        </header>
    );
};

function safeParse(value) {
    try {
        return value ? JSON.parse(value) : null;
    } catch {
        return null;
    }
}

export default AdminHeader;
